<script lang="ts" setup>

const props = defineProps<{
  tabsList: {
    name: string,
    value: string,
  }[],
  defaultTab?: string,
  direction?: 'column',
  naverColor?: 'orange' | 'blue',
}>();

const emits = defineEmits(['tab-setter'])

const tabs = ref<HTMLDivElement>();

let currentTab = ref('');
const naverParams = ref({
  transformX: 0,
  transformY: 0,
  width: 0,
  height: 0,
})

onMounted(() => {
  setTabValue(props.defaultTab || props.tabsList[0].value);
});

function setTabValue(tabValue: string) {
  if (tabValue) {
    currentTab.value = tabValue;
    setNaverPosition();
    emits('tab-setter', tabValue);
  }
}

function setNaverPosition() {
  const tabsWrapper = tabs.value;
  const tab = tabsWrapper?.querySelector(`.tabs-item[data-value="${currentTab.value}"]`) as HTMLElement;

  if (tab) {
    if (props.direction == 'column') {
      naverParams.value.transformY = tab.offsetTop;
    } else {
      if (tab.offsetLeft < 100) {
        naverParams.value.transformX = tab.offsetLeft - 4;
      } else {
        naverParams.value.transformX = tab.offsetLeft;
      }
    }
  }
}


</script>

<template>
  <div
    class="tabs"
    :class="[
      direction,
    ]"
    ref="tabs"
  >
    <div
      v-for="(tab, i) in tabsList"
      :key="`tab-item_${i}_${tab.value}`"
      @click="setTabValue(tab.value)"
      class="tabs-item"
      :data-value="tab.value"
      :class="[
        currentTab == tab.value && 'active'
      ]"
    >
      {{ tab.name }}
    </div>
    <div
      class="tabs-naver"
      :class="naverColor"
      :style="`
        transform: translate(${naverParams.transformX}px, ${naverParams.transformY}px) !important;
      `"
    ></div>
  </div>
</template>

<style lang="scss" scoped>
.tabs {
  position: relative;
  display: flex;
  border-radius: 8px;
  width: 100%;
  overflow: hidden;
  align-items: center;
  height: 100%;
  border: 4px solid #F0F0F0;
  background-color: $control-bg_neutral;
  &.hidden {
    visibility: hidden;
  }
  &-item {
    position: relative;
    z-index: 1;
    flex: 1;
    padding: 10px;
    color: $control-content_primary;
    text-align: center;
    cursor: pointer;
    @include font(14px, 20px, 500);
    transition: color .3s;

    &:hover:not(:active, .active) {
      @include mf-breakpoint {
        color: $control-content_orange;
      }
    }

    &.active {
      color: $control-content_white;
    }
  }

  &-naver {
    position: absolute;
    border-radius: 6px;
    width: 50%;
    height: 100%;
    transform: translate(0, 0);
    transition: {
      property: width;
      duration: 0.3s;
    }
    &.blue {
      background: #164996;
    }
    &.orange {
      background: #E95A2C;
    }
  }
  &.column {
    flex-direction: column;
  }
}
</style>
